import React, { Component } from 'react'
import ContentLoader from 'react-content-loader';
import Loader, {CircularLoader} from './Loader';



class RegisterCoursesUnitDetailsLoader extends React.Component {
    componentDidMount() {
        // course overview slider

        const $ = window.jQuery || window.$;
        $('.course-overview-slider').owlCarousel({
            items: 4,
            loop: false,
            margin: 20,
            dots: false,
            navText: [
                "<i class='fas fa-long-arrow-left'></i>",
                "<i class='fas fa-long-arrow-right'></i>"
            ],
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    nav: true
                },
                480: {
                    items: 1,
                    nav: true
                },
                576: {
                    items: 1,
                    nav: true
                },
                768: {
                    items: 2,
                    nav: true
                },
                992: {
                    items: 3,
                    nav: true
                },
                1200: {
                    items: 4,
                    nav: false,
                    loop: false
                }
            }
        });
    }
    render() {

        return (
            <div className="row no-gutters">
                <div className="col-lg-12">
                    <div className="card min-h-auto">
                        <div className="card-body">
                            <div
                                className="course-overview-slider owl-carousel owl-theme"
                                ref={el => (this.courseOverviewSlider = el)}
                            >
                                <div className="course-overview p-0 text-center">
                                    <div className="course-border">
                                        <div className="number m-0 fs-36-l"><CircularLoader /></div>
                                        <p><Loader height={50} width={700} /></p>
                                    </div>
                                </div>
                                <div className="course-overview p-0 text-center">
                                    <div className="course-border">
                                        <div className="number m-0 fs-36-l"><CircularLoader /></div>
                                        <p><Loader height={50} width={700} /></p>
                                    </div>
                                </div>
                                <div className="course-overview p-0 text-center">
                                    <div className="course-border">
                                        <div className="number m-0 fs-36-l">
                                            <CircularLoader />
                                        </div>
                                        <p><Loader height={50} width={500} /></p>
                                    </div>
                                </div>
                                <div className="course-overview p-0 text-center">
                                    <div className="border-0 course-border">
                                        <div className="number m-0 fs-36-l"><CircularLoader /></div>
                                        <p><Loader height={50} width={700} /></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* card for outstanding fees */}
                </div>
            </div>
        );
    }
}

export default RegisterCoursesUnitDetailsLoader;